export const LISTE_CONTRAT = {
  titleBaux: 'Liste des baux',
  titleBauxReconductible: 'Liste des baux reconductibles',
  titleBauxMateriel: 'Liste des baux par matériel',
  onglet: {
    contrat: 'Par bail',
    contratReconductible: 'A reconduire',
    materiel: 'Par matériel',
  },
  actions: {
    add: 'Nouveau bail',
    filtre: 'Filtre',
    edit: 'Modifier',
    delete: 'Supprimer',
    edition: 'Générer édition',
    editEtatNonRenouvelle: 'Ne pas renouveler',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence',
    bailleur: 'Bailleur',
    codeBail: 'Code(s) bail',
    codeFace: 'Code(s) face',
    etat: 'Etat du bail',
    natureContrat: 'Nature de bail',
    periodeDateContrat: 'Période de fin de contrat',
    datePreavis: 'Date de préavis',
    au: 'au',
    typeContrat: 'Type de bail',
    responsableBail: 'Responsable(s) bail',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    reconductible: 'Reconductible',
    estIndexe: 'Avec Indexation',
    demarcheur: 'Démarcheur(s)',
    motifDeBlocage: 'Motif de blocage',
    paiementSurFacture: 'Paiement sur facture',
    blocagePaiement: 'Blocage Paiement',
    secteurs: 'Secteur(s)',
    hasSecteur: 'Présent dans un secteur',
    etatRenouvellement: 'Renouvellement',
    motifNonRenouvellement: 'Motif de non renouvellement',
  },
  tab: {
    code: 'Code',
    type: 'Type',
    debutContrat: 'Début du contrat',
    finContrat: 'Fin du contrat',
    natureBail: 'Nature bail',
    bailleur: 'Bailleur(s)',
    loyer: 'Loyer HT annuel',
    etat: 'Etat',
    agence: 'Agence',
    indexation: 'Ind.',
  },
  typeContrat: {
    prive: 'Privé',
    concession: 'Concession',
    sousLocation: 'Sous location',
  },
  etatContrat: {
    brouillon: 'Brouillon',
    enregistre: 'Enregistré',
    clos: 'Clos',
  },
  exportExcel: {
    excelGenerateError: 'Impossible d\'exporter le fichier excel si il n\'y a pas de contrat',
    excelGenerateSuccess: 'Le fichier excel a été exporté avec succès',
    sheetName: 'Liste des contrats',
    excelTitle: 'listeContrats.xlsx',
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer ce bail ?',
    titleMulti: 'Êtes-vous sûr de vouloir supprimer ces baux ?',
    sucess: {
      bailDelete: 'Bail supprimé avec succès',
      bauxMulti: 'Les baux ont été supprimés avec succès.',
    },
    messagesError: 'Le bail {code} doit être à l\'état brouillon',
  },
  popUpAjoutSecteur: {
    notMatchSecteur: 'Le secteur sélectionné  n\'est sur aucun dispositif des matériels associés au(x) contrat(s) suivant(s) : {codes}',
  },
};

export const LISTE_CONTRAT_MATERIEL = {
  title: 'Liste des baux',
  actions: {
    exporter: 'Exporter',
    filtre: 'Filtre',
    edit: 'Modifier',
    delete: 'Supprimer',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence',
    bailleur: 'Bailleur(s)',
    codeBail: 'Code(s) bail',
    codeFace: 'Code(s) face',
    etat: 'Etat du bail',
    natureContrat: 'Nature de bail',
    periodeDateContrat: 'Période de fin de contrat',
    datePreavis: 'Date de préavis',
    codePostal: 'Code postal',
    localite: 'Localité(s)',
    au: 'au',
    materiel: 'Matériel(s)',
    typeContrat: 'Type de bail',
    search: 'Recherche...',
    noResult: 'Aucun résultat',
    emplacement: 'Emplacement(s)',
    dispositif: 'Dispositif(s)',
    departement: 'Département',
    secteurs: 'Secteur(s)',
    hasSecteur: 'Présent dans un secteur',
    exclureVilles: 'Exclure ville(s)',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  tab: {
    code: 'Code',
    natureBail: 'Nature bail',
    type: 'Type',
    bailleur: 'Bailleur(s)',
    debutContrat: 'Début du contrat',
    finContrat: 'Fin du contrat',
    libelleMateriel: 'Libellé du matériel',
    adresse: 'Adresse du matériel',
    codePostal: 'Code postal',
    localite: 'Localité',
    agence: 'Agence',
    departement: 'Département',
  },
  typeContrat: {
    prive: 'Privé',
    concession: 'Concession',
    sousLocation: 'Sous location',
  },
  etatContrat: {
    brouillon: 'Brouillon',
    enregistre: 'Enregistré',
    clos: 'Clos',
  },
};

export const LIST_BAUX_RECONDUCTIBLE = {
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    natureContrat: 'Nature de bail',
    typeContrat: 'Type de bail',
    periode: 'Période',
    parDateDe: 'Par date de',
    codeFace: 'Code(s) face',
    etatContrat: 'Etat du bail',
    termePaiementContrat: 'Terme de paiement',
    tacite: 'Issu de la reconduction',
    au: 'au',
    filtreParDate: {
      datePreavis: 'Date de préavis',
      dateFinEcheanceContrat: 'Date de fin d\'échéance du bail',
    },
    error: {
      dateWithFilterTypeEmpty: 'Le type de date est obligatoire pour filtrer sur une période.',
      filterTypeWithEmptyDate: 'La période est obligatoire pour filtrer par date.',
    },
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  tab: {
    code: 'Code',
    type: 'Type',
    finContrat: 'Fin du contrat',
    datePreavis: 'Date de préavis',
    dateFinEcheance: 'Date de fin d\'échéance',
    natureBail: 'Nature bail',
    bailleur: 'Bailleur(s)',
    loyer: 'Loyer HT',
    agence: 'Agence',
  },
  popUpReconduction: {
    title: 'Paramétrer la reconduction',
    multiModePaiementBailleur: 'Celui des bailleurs',
    multiTermePaiementContrat: 'Celui des baux',
    montantAnnuelleHt: 'Montant annuel HT',
    periodicite: 'Périodicité',
    tva: 'TVA',
    tousLes: 'Échéances tous les',
    reconduireSur: 'Reconduire pour',
    infoEcheance: 'Les échéances seront générées en fonction de la périodicité indiquée sur les baux',
    information: 'Information',
    termePaiement: 'Terme de paiement',
    modePaiement: 'Mode de paiement',
    success: {
      contratReconduit: 'Contrat(s) reconduit avec succès.',
    },
    error: {
      translate: {
        montantAnnuelHt: 'Montant annuele HT',
        reconductionContrat: 'Reconduire pour',
        tousLes: 'Échéances tous les',
      },
      forbiddenOnClosedContract: 'Interdit de reconduire le contrat clos {code}',
      contractShouldBeRenewable: 'Le contrat {code} doit être reconductible',
      leastOneProduct: 'Vous devez avoir au moins un matériel dans le(s) contrat(s)',
      bailleurModePaiement: 'Le mode de paiement est obligatoire pour le bailleur {bailleur}',
    },
    actions: {
      reconduire: 'Reconduire',
      cancel: 'Annuler',
    },
  },
  actions: {
    filtre: 'Filtre',
    reconduire: 'Reconduire',
  },
};

export const DETAIL_CONTRAT = {
  title: 'Détail du Bail n°{code}',
  tab: {
    bail: 'Bail',
    materielsAssocies: 'Matériels associés',
    echeancier: 'Echéancier',
    avenant: 'Avenants',
    commissions: 'Commissions',
  },
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des baux',
    detail: 'Détail du bail',
  },
  actions: {
    edit: 'Modifier',
    cloture: 'Clôturer le bail',
    reactiver: 'Réactiver le bail',
    enregistrer: 'Enregistrer le bail',
    renouvellement: 'Renouveler',
    masquerEcheancePaye: 'Masquer les échéances payées',
    creationFactureBailleur: 'Créer une facture bailleur',
    solderSansFacture: 'Solder sans facture ni paiement',
    reactiverEcheanceSoldee: 'Réactiver échéance soldée',
    generationFacture: 'Générer une facture',
    reconduire: 'Reconduire le bail',
    nonRenouvellement: 'Ne pas renouveler',
  },
  avenants: {
    title: 'Avenants',
    historique: 'Historique des avenants',
    noHistorique: 'Aucun avenant disponible pour ce bail',
    titleModif: '{user}',
  },
  echeancier: {
    title: 'Echéancier',
    periodeEcheance: 'Période d’échéance',
    montantHt: 'Montant Total HT',
    blocagePaiement: 'Blocage paiements',
    histo: 'Afficher historique',
    dateEcheancier: '{dateDebut} au {dateFin}',
    pasEcheance: 'Aucune échéance généré',
    soldeSansFacture: 'Soldée sans Facture',
    termePaiement: 'Terme de paiement',
    tabEcheance: {
      bailleur: 'Bailleur',
      produit: 'Produit(s)',
      multiProduit: 'Multiple',
      tooltip: {
        typeDePiece: 'Type de pièce',
        type: 'Type',
        code: 'Code',
        etat: 'Etat',
        montant: 'Montant Ttc',
        regle: 'Montant payé',
        date: 'Payée le',
        Od: 'Od',
        Paiement: 'Paiement',
        Charge: 'Charge',
      },
      faceEcran: 'Faces/Ecrans',
      montantHt: 'Montant HT période',
      montantTtc: 'Montant TTC période',
      dateEcheance: 'Date d’échéance',
      modePaiement: 'Mode paiement',
      debut: 'Début',
      fin: 'Fin',
      montantPaye: 'Mnt payé',
      totalBailleur: 'Total {bailleur}',
      aRapprocher: 'A rapprocher',
      montantFactureAchatTtc: 'Mnt appelé',
      paye: 'Payé',
      facture: 'Facture(s)',
      paiement: 'Paiement(s)',
      tauxTva: 'Taux TVA',
      actions: {
        solder: 'Solder',
        reactiver: 'Réactiver',
        payer: 'Payer',
        annulerCharge: 'Annuler la charge',
        annulerPaiement: 'Annuler les paiements',
      },
    },
    annulerCharge: {
      titre: 'Etes-vous sûr de vouloir annuler la charge ?',
      checkbox: 'Supprimer la constatation de charges si possible',
    },
    generationFacture: 'Etes-vous sûr de vouloir générer une facture ?',
    exportExcel: {
      excelTitle: 'echeanciers',
    },
    actionErrors: {
      noARapprocher: 'Action incompatible avec une échéance "A Rapprocher" pour le bailleur {bailleur} en date d\'échéance au {dateEch}',
      badStateFacture: 'L\'échance du bailleur {bailleur} en date du {dateEch} est facturée, action incompatible',
      badStateBrouillon: 'L\'échance du bailleur {bailleur} en date du {dateEch} est en brouillon, action incompatible',
      badStatePayee: 'L\'échance du bailleur {bailleur} en date du {dateEch} est payée, action incompatible',
      badState: 'La commande d\'achat {cmdCode} doit être à l\'état "enregistrée"',
      billboardLineBillDoneStateInvalid: 'Aucune ligne d\'échéancier avec la facturation faite ne peut exister pour la commande d\'achat {cmdCode}',
      notClearedWithoutBill: 'L\'échance du bailleur {bailleur} en date du {dateEch} n\'est pas soldée sans facture ni paiement',
      billboardLineRealBillExists: 'La commande d\'achat {0} possède au moins une vrai facture, action incompatible',
      billboardLineBillDoneStateInvalidToo: 'Aucune ligne d\'échéancier sans la facturation faite ne peut exister pour la commande d\'achat {cmdCode}',
      unsoldeBadState: 'La commande d\'achat {cmdCode} doit être à l\'état "facturée"',
      allARapprocher: 'Les échéances doivent toutes être à rapprocher',
      allSameTiers: 'Les échéances doivent avoir le même bailleur',
      allNoFacture: 'Les échéances ne doivent pas être liées à une facture',
    },
  },
  cloture: {
    clotureTitle: 'Etes-vous sûr de vouloir clôturer ce contrat ?',
    successCloture: 'Contrat cloturé avec succès.',
    dateCloture: 'Date clôture',
    deleteEcheance: 'Supprimer les échéances de bail plus récentes que la date de clôture choisie et non payées',
    dateClotureInferieurDateDebutContrat: 'La date de clôture doit être supérieure à la date de début du contrat',
  },
  reactivation: {
    reactivationTitle: 'Etes-vous sûr de vouloir réactiver ce contrat ?',
    successReactivation: 'Contrat réactivé avec succès.',
  },
  enregistrement: {
    enregistrementTitle: 'Etes-vous sûr de vouloir enregistrer ce contrat ?',
    successEnregistrement: 'Contrat enregistré avec succès.',
  },
  infoBail: {
    title: 'Informations du bail',
    code: 'Bail n°{code}',
    typeBail: 'Type de bail : {type}',
    natureBail: 'Nature du bail : {nature}',
    contrat: {
      title: 'Contrat',
      periodeContrat: 'Période du contrat :',
      periodeEcheancier: 'Période de l\'écheancier :',
      echeanceTousLes: 'Echéance tous les :',
      periode: 'Du {dateDebut} au {dateFin} ({periode})',
      periodeEcheance: '{quantite} {unite}',
      dateDebutContrat: 'Date de début du contrat :',
      dateFinContrat: 'Date de fin du contrat :',
      dureeContractuelle: 'Durée contractuelle :',
      datePreavis: 'Date de préavis :',
      dateSignature: 'Date de signature',
      signataire: 'Signataire :',
      demarcheur: 'Démarcheur :',
      commission: 'Commission :',
      responsableBail: 'Responsable du bail :',
    },
    bailleurs: {
      title: 'Bailleurs',
      quotePart: 'Quote-part : {quotePart}%',
      paiement: 'Paiement : {paiement}',
      surFacture: 'Paiement sur facture :',
      email: 'Email :',
      telephone: 'Téléphone :',
      yes: 'Oui',
      no: 'Non',
    },
    infoFinancieresLoyer: {
      title: 'Informations financières / Loyer annuel',
      montantHt: 'Montant HT',
      tauxTva: 'Taux TVA %',
      tva: '{tva} %',
      montantTtc: 'Montant TTC',
    },
    secteur: 'Secteur : {secteur}',
  },
  renouvellement: {
    title: 'Renouvellement',
    contrat: {
      etatRenouvellement: 'Etat renouvellement : ',
      motifNonRenouvellement: 'Motif de non renouvellement : ',
      reconductible: 'Reconductible tacitement : ',
      tacite: 'Issu d\'une reconduction : ',
      yes: 'Oui',
      no: 'Non',
    },
    popupNonRenouvellement: {
      title: 'Êtes-vous sûr de vouloir définir ce(s) contrat(s) comme non renouvelable(s)',
      confirmation: 'Êtes-vous sûr de vouloir rendre ce(s) contrat(s) non renouvelable(s)',
      successNonRenouvellement: 'Contrat(s) non renouvelé(s) avec succès',
    },
  },
  indexation: {
    title: 'Indexation',
    valeurIndexationPourcentage: 'Valeur (%)',
    pourcentageIndexation: '{value}%',
    indiceReference: 'Nom de l\'indice',
    typeIndexation: 'Type d\'indexation',
    dateIndexationReference: 'Date de l\'indice de référence',
    valeurIndexationReference: 'Valeur d\'indice de référence',
    dateIndexationActuel: 'Date de l\'indice de actuel',
    valeurIndexationActuel: 'Valeur d\'indice de actuel',
    valeurLorsIndexation: 'Valeur d\'indice lors de l\'indexation',
    dateLorsIndexation: 'Date de l\'indice lors de l\'indexation',
    dateDerniereIndexation: 'Date dernière indexation',
    montantIndexationReference: 'Loyer de référence',
    affichageDonneeIndexation: 'Afficher les données de l\'indexation',
    typePourcentage: 'Pourcentage',
    typeIndice: 'Indice',
    estIndexe: 'Indexé',
    inderBail: 'Indexer le bail',
    successIndexationMsg: 'Le bail a été indexé avec succès',
    montantLoyerIndexe: 'Montant du loyer indexé',
    echeancierNonIndexable: 'Cette écheancier ne peut pas être indexé',
    dateDebutContrat: 'Date de début du contrat',
    dateFinContrat: 'Date de fin du contrat',
    dateSignature: 'Date de la signature du contrat',
    popUpIndexation: {
      title: 'Indexation du bail',
      titleEcheancier: 'Détail de l\'indexation',
      tabIndexation: 'Indexation',
      tabEcheancier: 'Echéancier ({nb})',
      dateIndexation: 'Date de l\'indexation',
    },
  },
  commentaire: {
    title: 'Commentaire',
    commentaire: 'Commentaire :',
  },
  contrepartie: 'Contrepartie :',
  pj: {
    title: 'Pièces-jointes',
  },
  steps: {
    infoBail: 'Informations du bail',
    indexation: 'Indexation',
    commentaires: 'Commentaires',
    piecesJointes: 'Pièces jointes',
    contrepartie: 'Contrepartie',
  },
  info: {
    avertissement: {
      noMateriel: 'Aucun matériel n\'a été ajouté au bail',
      noEcheancier: 'Aucun échéancier n\'a été ajouté au bail',
    },
  },
  popupSelectionIntervenant: {
    title: 'Séléctionner l\'intervenant de la facture bailleur',
    selectIntervenant: 'Bailleur :',
  },
  popUpSuppression: {
    messagesSuccess: 'Bail supprimé avec succès',
    title: 'Etes-vous sûr de vouloir supprimer ce bail ?',
  },
  blocagePaiement: 'Blocage paiement',
};

export const ADD_EDIT_CONTRAT = {
  title: {
    add: 'Créer un bail',
    edit: 'Modifier le bail {code}',
  },
  actions: {
    brouillon: 'Brouillon',
    cancel: 'Annuler',
    edit: 'Modifier',
    remove: 'Supprimer',
    masquerEcheancePaye: 'Masquer les échéances payées',
    addDemarcheur: 'Créer un démarcheur',
  },
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des baux',
    add: 'Créer un bail',
    edit: 'Modifier un bail',
  },
  tab: {
    bail: 'Bail',
    materielsAssocies: 'Matériels associés',
    produitsAssocies: 'Produits associés',
    echeancier: 'Echéancier',
    avenants: 'Avenants',
  },
  updateARapprocher: {
    title: 'Le taux de TVA ayant changé, voulez-vous passer toutes vos échéances à rapprocher ?',
  },
  echeancier: {
    title: 'Paramétrages échéancier',
    periodeEcheance: 'Période d’échéance',
    montantHt: 'Montant Total HT',
    echeancierlibelle: 'Echéancier',
    blocagePaiement: 'Blocage paiements',
    dateEcheancier: '{dateDebut} au {dateFin}',
    genererEcheancier: 'Générer échéancier',
    pasEcheance: 'Aucune échéance généré',
    info: {
      noGenerate: 'Vous ne pouvez pas générer d\'échéancier',
      echeanceOutsideTitle: 'Echéance(s) en dehors des dates du bail',
      echeanceOutsidePeriode: 'L\'échéance de {tiers} du {dateEcheance}, d\'un montant de {montantEcheance}€ est en dehors de la période d\'échéance du bail ({debutBail} - {finBail}).',
      message: 'Il faut au moins un bailleur et un matériel associé pour pouvoir générer votre échéancier',
      aucunMotifBlocage: 'Aucun motif de blocage',
      bailleurBlocageReglement: 'Le bailleur {nom} à un blocage en paiement. Motif: {motif}',
    },
    detailProduit: {
      titlePatrimoine: 'Détail des faces / écrans',
      titleProduit: 'Détail des produits',
      infoEcheance: 'Bailleur {bailleur}, échéance du {date} d\'un montant TTC de {montantTtc}',
      libelle: 'Libellé',
      close: 'Fermer',
    },
    popUpInformationCommentaire: {
      title: 'Liste des commentaires',
      commentaireEcheance: 'Commentaire échéance',
      commentairesReplanification: 'Commentaires replanification',
      tab: {
        commentaire: 'Commentaire',
        user: 'Utilisateur',
        date: 'Date',
      },
      actions: {
        close: 'Fermer',
      },
    },
    popUpGestionCommentaire: {
      title: 'Modifier le commentaire de l\'échéance',
      commentaire: 'Commentaire',
    },
    popUpBailleur: {
      title: 'Modifier le bailleur',
      bailleur: 'Bailleur',
      replaceBailleur: 'Remplacer le bailleur',
      actions: {
        cancel: 'Annuler',
        remplacer: 'Remplacer',
        noResult: 'Aucun résultat',
        searchEnCours: 'Recherche...',
      },
      error: 'Vous devez rechercher un bailleur pour remplacer l\'ancien.',
    },
    popupPayer: {
      title: 'Payer {montantEcheance} € par {mode} à {tiers}',
      periode: 'Période du {debut} au {fin}',
      libelleLot: '{code} - {echeance} - {tiers}',
      libelle: 'Libelle',
      datePaiement: 'Date paiement (date comptable)',
      domiciliation: 'Banque',
      numero: 'Numéro de paiement',
      actions: {
        payer: 'Payer',
      },
    },
    popupAnnulationPaiement: {
      title: 'Annulation des paiements',
      actions: {
        annulerPaiements: 'Annuler les paiements',
      },
      columns: {
        modePaiement: 'Mode',
        dateEcheance: 'Date',
        debit: 'Montant',
        remise: 'Remise bancaire',
        numeroPaiement: 'Numéro',
        bailleur: 'Bailleur',
        debutPeriode: 'Période du',
        finPeriode: 'au',
        montantTtc: 'Montant Echéance',
      },
      errors: {
        emptySelection: 'La sélection d\'au moins un paiement à annuler est obligatoire',
        canOnlyCancelPaiement: 'Seul les mouvements de type paiement peuvent être annulés',
        canOnlyCancelPaiementLinedWithBill: 'Seul les paiements liés à des factures de charge peuvent être annulés',
      },
    },
    tabEcheance: {
      bailleur: 'Bailleur',
      faceEcran: 'Faces/Ecrans',
      goToBail: 'Aller sur le bail',
      demandeAvoirBailleur: 'Demande avoir bailleur',
      produit: 'Produit(s)',
      multiProduit: 'Multiple',
      montantHt: 'Montant HT période',
      montantTtc: 'Montant TTC période',
      dateEcheance: 'Date d’échéance',
      aRapprocher: 'A rapprocher',
      debut: 'Début',
      fin: 'Fin',
      facture: 'Facture(s)',
      paiement: 'Paiement(s)',
      montantPaye: 'Mnt payé',
      totalBailleur: 'Total {bailleur}',
      montantFactureAchatTtc: 'Mnt appelé',
      modePaiement: 'Mode paiement',
      paye: 'Payé',
      tauxTva: 'Taux TVA',
      montantHtIndexe: 'Montant indexé',
      actions: {
        supprimer: 'Supprimer',
        editCommentaire: 'Gérer le commentaire',
        addTiers: 'Remplacer le bailleur',
      },
      message: {
        successAnnulerCharge: 'La charge a été annulée avec succès.',
        erreurCoherenceEcheancierFacturation: 'Il y a une incohérence entre l\'échéancier de ce contrat et les factures de charge. Action impossible, merci de contacter l\'assistance.',
        sucessDeleteEcheance: 'L\'échéance a été supprimée avec succès.',
        sucessDeleteEcheances: 'Le(s) échéance(s) ont été supprimée(s) avec succès.',
        successPayer: 'L\'échéance a été payée.',
      },
    },
    popUpCreation: {
      title: 'Paramétrage de l’échéancier',
      titleSuppressionEcheance: 'Confirmation de la suppression partielle',
      bailleurs: 'Bailleur(s)',
      quotePart: 'Quote part : {percent}%',
      modePaiementBailleur: 'Mode de paiement : {modePaiement}',
      multiModePaiementBailleur: 'Celui des bailleurs',
      debutEcheancier: 'Début de l’échéancier',
      finEcheancier: 'Fin de l’échéancier',
      dateFinEcheance: 'Date de fin de 1er échéance',
      montantAnnuelleHt: 'Montant annuel HT',
      periodicite: 'Périodicité',
      aucunBailleur: 'Aucun bailleur ajouté dans le contrat.',
      tva: 'TVA',
      tousLes: 'Tous les',
      montantDe: 'un montant de',
      htEtTva: 'HT et une TVA de',
      termePaiement: 'Terme de paiement',
      modePaiement: 'Mode de paiement',
      deleteEcheanceExistante: 'Supprimer automatiquement les échéances existantes supprimables avec une période incluse dans la période de génération',
      prevInformation: 'Certaines des échéances à supprimer ont déjà été constatées ou débordent de votre période de génération. Merci de vérifier les impacts avant de confirmer car elles ne seront pas supprimées.',
      attention: 'Attention',
      messages: {
        error: {
          bailleurModePaiement: 'Le mode de paiement est obligatoire pour le bailleur {bailleur} ',
          tva: 'Le pourcentage de TVA est obligatoire.',
          outOfRangePeriode: 'La période doit être superieur à zéro.',
          impossible: 'Impossible de générer l\'écheancier.',
          dateDebutRequire: 'Début de l’échéancier',
          dateFinRequire: 'Fin de l’échéancier',
          peiodiciteRequire: 'Tous les',
          repartitionError: 'La répartition des bailleurs doit être inférieur ou égale à 100%.',
          montantAnuelleRequired: 'Montant annuel HT',
          firstEcheanceOutside: 'La date de fin de la 1er échéance, est en dehors de l\'échéancier.',
          dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin.',
          duplicationInterdite: 'Il est interdit de dupliquer les bailleurs.',
        },
      },
      actions: {
        precedent: 'Précédent',
        continuer: 'Continuer',
        annuler: 'Annuler',
        genererEcheancier: 'Générer l’échéancier',
        dateDifferent: 'Votre période de génération ne correspond pas à la période d\'échéance du contrat.',
        actualisation: 'Cette dernière sera actualisée en conséquence.',
        quantiteUniteDiff: 'La périodicité ne correspond pas à la périodicité du contrat.',
      },
    },
    ajoutEcheancierManuel: 'Ajouter une échéance manuellement',
    popUpAjoutEcheancierManuel: {
      title: 'Ajouter un écheancier manuel',
      bailleur: 'Bailleur',
    },
  },
  informationsGenerales: {
    title: 'Informations générales',
    code: 'Code',
    typeBail: 'Type de bail',
    natureBail: 'Nature de bail',
    agence: 'Agence',
    secteur: 'Secteur',
  },
  contrat: {
    title: 'Contrat',
    dateDebut: 'Date début contrat',
    dateFin: 'Date fin contrat',
    dureeContractuelle: 'Durée contractuelle',
    nbAn: 'Nb an(s)',
    duree: {
      year: '{nb} an(s)',
      mois: '{nb} mois',
      jours: '{nb} jour(s)',
    },
    datePreavis: 'Date préavis',
    dateSignature: 'Date de signature',
    signataire: 'Signataire',
    reconductible: 'Reconductible tacitement',
    tacite: 'Issu d\'une reconduction',
    commission: 'Commission',
    demarcheur: 'Démarcheur',
    responsableBail: 'Responsable du bail',
    titleResponsableDemarcheur: 'Responsable / Démarcheur',
  },
  renouvellement: {
    title: 'Renouvellement',
    contrat: {
      etatRenouvellement: 'Etat renouvellement ',
      motifNonRenouvellement: 'Motif de non renouvellement ',
      reconductible: 'Reconductible tacitement',
      tacite: 'Issu d\'une reconduction ',
    },
  },
  bailleur: {
    title: 'Bailleur',
    bailleur: 'Bailleur',
    adresse: 'Adresse',
    quotePart: 'Quote-part',
    modePaiement: 'Mode de paiement',
    consulter: 'Consulter',
    ajouter: 'Ajouter',
    ajouterBailleur: 'Ajouter un bailleur',
    addNewBailleur: 'Créer un nouveau bailleur',
    pourcentage: '%',
    surFacture: 'Paiement sur facture',
    newBailleur: {
      title: 'Créer un bailleur',
      infoGeneral: 'Informations générales',
      adresse: 'Adresse',
      actions: {
        cancel: 'Annuler',
        create: 'Créer',
      },
    },
  },
  informationFinanciere: {
    title: 'Informations financières / Loyer annuel',
    montantHt: 'Montant HT annuel',
    tauxTva: 'Taux TVA %',
    montantTtc: 'Montant TTC',
    loyerAnnuelTva: 'Loyer annuel TVA',
  },
  echeance: {
    title: 'Echéances',
    dateDebutEcheance: 'Date début échéance',
    dateFinEcheance: 'Date fin échéance',
    dureePeriodeEcheance: 'Durée période échéance',
    termePaiementLibelle: 'Terme de paiement',
    periodicite: 'Périodicité',
    termePaiement: {
      echu: 'Echu',
      avance: 'Avance',
    },
  },
  indexation: {
    title: 'Indexation',
    typeIndexation: 'Type d\'indexation',
    montantIndexationReference: 'Loyer de référence',
    dateDerniereIndexation: 'Date dernière indexation',
    valeurIndexationPourcentage: 'Valeur (%)',
    valeurReference: 'Valeur de Référence',
    valeurActuelle: 'Valeur actuelle',
    dateIndice: 'Date de l\'indice',
    valeurIndice: 'Valeur de l\'indice',
    personnalise: 'Personnalisé',
    nomIndice: 'Nom de l\'indice',
    affichageDonneeIndexation: 'Afficher les données de l\'indexation',
    echeanceIndexee: 'Les échéances indexées suivantes ont été modifiées:',
    echeanceIndexeeDate: 'Echéance de {tier} du {debut} au {fin}',
  },
  commentaire: {
    title: 'Commentaire',
    commentaire: 'Commentaire',
  },
  contrepartie: {
    title: 'Contrepartie',
    contrepartie: 'Contrepartie',
  },
  pj: {
    title: 'Pièces jointes',
  },
  materiel: {
    title: 'Matériels associés',
    aucunMateriel: 'Aucun matériel n\'a été associé',
    aucunResult: 'Aucun résultat',
    addMateriel: 'Ajouter un matériel pour l\'associer au bail',
    successAdd: 'Matériel ajouté avec succès',
    displayInactif: 'Afficher les éléments archivés',
    displayActif: 'Masquer les éléments archivés',
    actions: {
      search: 'Rechercher par code',
      searchEnCours: 'Recherche...',
      noResult: 'Aucun résultat',
      associer: 'Associer un matériel par son code',
      addMaterielMultiple: 'Ajouter des matériels',
    },
  },
  produit: {
    title: 'Produits associés',
    aucunProduit: 'Aucun produit n\'a été associé',
    aucunResult: 'Aucun résultat',
    addProduit: 'Ajouter un produit',
    successAdd: 'Produit ajouté avec succès',
    actions: {
      search: 'Rechercher par code',
      searchEnCours: 'Recherche...',
      noResult: 'Aucun résultat',
      associer: 'Associer un matériel par son code',
      addMaterielMultiple: 'Ajouter des matériels',
    },
    tab: {
      reference: 'Référence',
      type: 'Type',
      libelle: 'Libellé',
    },
  },
  messages: {
    problemOccurred: 'Un problème est survenu',
    success: {
      add: 'Le bail a été ajouté avec succès',
      edit: 'Le bail a été modifié avec succès',
      successCreation: 'Le démarcheur a été créé avec succès.',
    },
    warning: {
      updateTauxTva: 'Le taux tva ayant changé, veuillez vérifier l\'échéancier',
    },
    errors: {
      champs: {
        natureId: 'Nature de bail',
        code: 'Code',
        montantHtEcheance: 'Montant HT période',
        datePreavis: 'Date préavis',
        dateFinEcheance: 'Date fin échéance',
        dateDebutEcheance: 'Date début échéance',
        dateDebutSignature: 'Date début de contrat',
        dateFinSignature: 'Date fin de contrat',
        quantitePeriodicite: 'Quantité de périodicité',
        dateCloture: 'Date de clôture',
        contrepartie: 'Contrepartie',
        commentaire: 'Commentaire',
        indexe_dateIndexation: 'Date de l\'indexation',
        indexe_valeurIndexationActuel: 'Valeur de l\'indice',
        motifNonRenouvellement: 'Motif de non renouvellement',
      },
      codeRequired: 'Le code est obligatoire.',
      invoiceCodeMustBeReplacedFully: 'Le code {code} du bail n\'a pas pu être généré complètement.',
      loyerAnnuelMandatoryCreation: 'Le produit loyer annuel de la société est obligatoire pour la création d\'un contrat de bail.',
      loyerAnnuelMandatoryModification: 'Le produit loyer annuel de la société est obligatoire pour la modification d\'un contrat de bail.',
      stringLength: 'Le champ \'{champs}\' doit contenir entre 1 et 20 caractères.',
      dateRequiredDatePreavis: 'La date est requise pour le champ \'date préavis\'.',
      productRentRequired: 'La société doit avoir un produit de location',
      mustHaveIntervenant: 'Vous devez avoir au minimum un intervenant et une quote-part de 100% maximum.',
      leastOneProduct: 'Vous devez avoir au moins un matériel.',
      dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin.',
      dateEcheanceOutside: 'La date d\'échéance est en dehors de l\'échéancier.',
      stateSavedRequired: 'Impossible de supprimer des échéances déjà facturées ou partiellement facturées.',
      materielWithoutFace: 'Le matériel {code} doit avoir au moins une face associée',
      dispositifWithoutAddress: 'Impossible de sauvegarder des échéances sur le contrat {codeContrat} lorsque le(s) dispositif(s) {codesDispositifs} ont une adresse incorrecte. Veuillez les vérifier depuis la liste des matériels associés',
      notFilledMontantIndexationReference: 'Indexation impossible. Le montant de référence n\'est pas rempli',
      notFilledTypeIndexation: 'Indexation impossible. Le type d\'indexation n\'est pas rempli',
      notFilledValeurIndexationActuel: 'Indexation impossible. La valeur actuelle d\'indexation n\'est pas rempli',
      notFilledValeurIndexationReference: 'Indexation impossible. La valeur de référence d\'indexation n\'est pas rempli',
      contratNotBeenIndexed: 'Le contrat ne peut être indexé',
      notSameCompanyLessor: 'Le contract n\'est pas sur la même société que le bailleur',
      notSameCompanyBillboard: 'Un matériel est sur une société differente du contrat',
      notMatchSecteur: 'Le secteur sur le contrat n\'est sur aucun dispositif des matériels associés',
    },
    info: {
      title: 'Information',
      generationEcheancier: 'N\'oubliez pas de générer votre échéancier.',
    },
  },
  demarcheur: {
    raisonSociale: 'Raison sociale',
    compteComptable: 'Compte comptable',
    adressePostale: 'Adresse postale',
    adresse: 'Adresse',
    addDemarcheur: 'Ajouter un démarcheur',
  },
};

export const ADD_MATERIEL_CONTRAT = {
  title: 'Ajouter du patrimoine à votre bail',
  breadcrumb: {
    home: 'Accueil',
    liste: 'Liste des baux',
    addContrat: 'Ajouter un bail',
    editContrat: 'Modifier un bail',
    addMateriel: 'Ajouter un matériel',
  },
};
